export const Threshold = {
    Column: 25,
    Base: 25,
    Arm: 120,
    Bracing: 100,
    "Base Kit": 50,
    Nuts: 100,
    Frame: 10,
    Beam: 50
}